import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import type { CashierConfig, CashierConfigListRequestParams } from '@/models/cashier-settings/cashier-settings.model';
import { clearObj } from '@marfa/bo-utils';

export default class GetCashierConfigListRequest extends ApiResourceMethod<CashierConfig[]> {
  public perform(params: CashierConfigListRequestParams): Promise<CashierConfig[]> {
    return this.performer.requestWithMapper(
      { params: clearObj(params) },
      (response: BaseResponse<CashierConfig[]>) => response.data,
    );
  }
}
